/**
 * 唯一的 Toast 出口。引擎/传输层的错误（E_STALE_ACTION、人数不足…）都由
 * localSession 灌进 uiStore，这里只管显示与自动消失。
 *
 * durationMs === 0 表示「必须手动关」—— 筹码不守恒这种错不能自己溜走。
 */
import { useEffect } from 'react'
import type { ReactNode } from 'react'

import { useUiStore } from '../store/index.js'
import './session.css'

export function Toasts(): ReactNode {
  const toast = useUiStore((s) => s.toast)
  const dismiss = useUiStore((s) => s.dismissToast)

  useEffect(() => {
    if (toast === null || toast.durationMs <= 0) return undefined
    const t = setTimeout(dismiss, toast.durationMs)
    return () => clearTimeout(t)
    // id 变了就是换了一条消息：同文案的第二条也要重新计时
  }, [toast?.id, toast?.durationMs, toast, dismiss])

  if (toast === null) return null
  return (
    // 不挂 onClick：CSS 里 pointer-events:none（理由写在 session.css），点不到也不该点到
    <div className="toast" data-tone={toast.tone} role="status">
      {toast.text}
    </div>
  )
}

export default Toasts
